import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=36513b43&scoped=true&"
import script from "./FooterNav.vue?vue&type=script&lang=ts&"
export * from "./FooterNav.vue?vue&type=script&lang=ts&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=36513b43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36513b43",
  null
  
)

export default component.exports